module.exports = __webpack_public_path__ + "img/main-03-07-JP.726f4cfa.png";